import Header from './components/Header';
import Hero from './components/Hero';
import WhyChooseUs2 from './components/WhyChooseUs2';
//import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
//import Portfolio from './components/Portfolio';
import Pricing from './components/Pricing';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <WhyChooseUs2 />

      <Services />

      <Pricing />
      <Process />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
